export default "<small class=\"n2p-input-hint\">\n  <ng-content></ng-content>\n</small>\n"